// extracted by mini-css-extract-plugin
export default {"item":"item--7c8Ez","link":"link--gyyWk","icon":"icon--ceNel"};